export default __webpack_public_path__ + "static/media/PalaikuKremavimas.a4453005.svg";